import React, { useState, useEffect } from 'react';
import { Container, Card, Badge, Button, Row, Col } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import moment from 'moment';
import { FaDownload } from 'react-icons/fa';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const TenderDetail = () => {
  const { slug } = useParams();
  const [tender, setTender] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTender();
  }, [slug]);

  const loadTender = async () => {
    try {
      const response = await api.get(`/tenders/${slug}/`);
      setTender(response.data);
    } catch (error) {
      console.error('Error loading tender:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!tender) {
    return (
      <Container className="py-5">
        <h1>Tender Not Found</h1>
        <Link to="/tenders" className="btn btn-primary">Back to Tenders</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row>
        <Col lg={8}>
          <h1>{tender.title}</h1>
          <h5 className="text-muted">Tender No: {tender.tender_no}</h5>
          <div className="my-3">
            <Badge bg={
              tender.status === 'open' ? 'success' :
              tender.status === 'closed' ? 'secondary' :
              tender.status === 'awarded' ? 'primary' : 'danger'
            }>
              {tender.status.toUpperCase()}
            </Badge>
          </div>
          <div dangerouslySetInnerHTML={{ __html: tender.description }} />
          
          {tender.tender_document && (
            <div className="mt-4">
              <Button 
                variant="success" 
                href={getMediaUrl(tender.tender_document)} 
                target="_blank"
                size="lg"
              >
                <FaDownload className="me-2" />
                Download Tender Document
              </Button>
            </div>
          )}
        </Col>
        <Col lg={4}>
          <Card>
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">Tender Information</h5>
            </Card.Header>
            <Card.Body>
              <p><strong>Department:</strong> {tender.department_name}</p>
              <p><strong>Published:</strong> {moment(tender.published_date).format('MMM DD, YYYY')}</p>
              <p><strong>Deadline:</strong> {moment(tender.submission_deadline).format('MMM DD, YYYY')}</p>
              {tender.opening_date && (
                <p><strong>Opening:</strong> {moment(tender.opening_date).format('MMM DD, YYYY')}</p>
              )}
              {tender.estimated_cost && (
                <p><strong>Estimated Cost:</strong> ₹{tender.estimated_cost.toLocaleString()}</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <div className="mt-4">
        <Link to="/tenders" className="btn btn-outline-primary">← Back to Tenders</Link>
      </div>
    </Container>
  );
};

export default TenderDetail;
